import { combineReducers } from 'redux';

import mealTypes from 'PointOfSale/modules/mealTypes/state/reducer';
import servingOptions from 'PointOfSale/modules/servingOptions/state/reducer';
import cepCard from 'PointOfSale/modules/cepCard/state/reducer';
import queue from 'PointOfSale/modules/queue/state/reducer';
import lookUp from 'PointOfSale/modules/lookup/state/reducer';
import group from 'PointOfSale/modules/group/state/reducer';
import teacher from 'PointOfSale/modules/teacher/state/reducer';
import dateAndSiteDetails from 'PointOfSale/modules/setDateAndSite/state/reducer';
import serving from 'PointOfSale/modules/individualServing/state/reducer';
import common from 'PointOfSale/state/reducer';
import viewTransactionHistory from 'PointOfSale/modules/history/state/reducer';

export default combineReducers({
  common,
  mealTypes,
  servingOptions,
  cepCard,
  queue,
  lookUp,
  group,
  teacher,
  dateAndSiteDetails,
  serving,
  viewTransactionHistory,
});



// WEBPACK FOOTER //
// ./src/pages/pointofsale/reducer.js